import { MatchMode } from '../../interfaces/whitelisted_plate';

export const matchModeLabels: Record<MatchMode, string> = {
  exact: 'Exact match',
  prefix: 'Starts with',
};
